import React from 'react';

export default function MainHome() {
  return (
    <div className='screen-container' style={{ backgroundImage: 'url("/Thumbnail.png")', backgroundSize: 'cover', backgroundPosition: 'center', width: '100%', height: '100%' }}>
    </div>
  );
}
